import { makeObservable, observable } from 'mobx';
import StoreService from '../services/storeServices';

export default class TourStore {
  showTour = false;

  steps = [];

  storeService;

  key;

  constructor(key, showTour = false, steps = []) {
    this.key = key;
    this.storeService = new StoreService(key);
    this.showTour = showTour;
    this.steps = steps;
    makeObservable(this, { showTour: observable });
  }
}
